import { ContainerEtapa } from '../../../styles';
import TextField, { TextFieldSize } from '@/components/molecules/TextField';
import { Controller } from 'react-hook-form';
import TextFieldCPF from '@/components/molecules/TextFieldCPF';
import { EtapaCadastroProps, EtapaDadosPessoaisCadastro } from '../../..';
import { CSSProperties } from 'react';
import TextFieldDataNascimento from '@/components/molecules/TextFieldDataNascimento';
import SelectIdentidadeGenero from '@/components/molecules/SelectIdentidadeGenero';

type EtapaDadosPessoaisProps = EtapaCadastroProps &
  EtapaDadosPessoaisCadastro & {
    style?: CSSProperties;
    inputSize?: TextFieldSize;
    styleConteudoDropdown?: CSSProperties;
    cpfObrigatorio?: boolean;
  };

export default function EtapaDadosPessoais(props: EtapaDadosPessoaisProps) {
  const {
    style,
    $errors,
    $control,
    $register,
    $selecionarIdentidadeGenero,
    $opcoesIdentidadeGenero,
    inputSize = 2,
    styleConteudoDropdown,
    cpfObrigatorio = false,
  } = props;
  return (
    <ContainerEtapa style={style}>
      <TextField
        $size={inputSize}
        $variant="surface"
        $state="placeholder"
        $error={$errors.nome?.message ?? false}
        $label="Digite seu nome completo"
        $focusRing={false}
        $placeholder="Nome Completo"
        $name="nome"
        $inputProps={$register('nome')}
        $obrigatorio={true}
      />
      <Controller
        name="cpf"
        control={$control}
        render={({ field }) => (
          <TextFieldCPF
            $errors={$errors}
            $field={field}
            $obrigatorio={cpfObrigatorio}
            $size={inputSize}
          />
        )}
      />
      <Controller
        name="dataNascimento"
        control={$control}
        render={({ field }) => (
          <TextFieldDataNascimento
            $errors={$errors}
            $field={field}
            inputSize={inputSize}
          />
        )}
      />
      <Controller
        name="tipoGeneroID"
        control={$control}
        render={({ field }) => (
          <SelectIdentidadeGenero
            $errors={$errors}
            $field={field}
            $selecionarIdentidadeGenero={$selecionarIdentidadeGenero}
            $opcoesIdentidadeGenero={$opcoesIdentidadeGenero}
            selectSize={inputSize}
            styleConteudoDropdown={styleConteudoDropdown}
          />
        )}
      />
    </ContainerEtapa>
  );
}
